module.exports = __webpack_public_path__ + "static/media/image6.832b0f88.webp";